const config = {
  month: 'hmUI.date.MONTH',
  day: 'hmUI.date.DAY',
  week: 'hmUI.date.WEEK'
}

export default config
